import {InputAdornment, TextField} from "@mui/material";
import {Search} from "@mui/icons-material";

const SearchBox = ({style, value, onChange, error, theme, placeholder}) => {
    const hasValue = Array.isArray(value) ? value.length > 0 : value !== '' && value != null && value !== undefined;

    const isDark = theme.White !== "#FFFFFF";
    const bgColor = isDark ? theme.Coco : theme.Checo
    return (
        <TextField
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder= {placeholder || "Buscar"}
            variant="outlined"
            style={style}
            sx={{   //Permite sobreescribir algunos estilos
                "& .MuiInputBase-root": { //Altura del componente
                    width: style.width,
                    height: style.height,
                    borderRadius: '4px',
                    gap: '12px',
                    borderWidth: '1px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    paddingRight: '12px',

                },
                "& .MuiOutlinedInput-root": {
                    backgroundColor: bgColor, //Fondo del textfield
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { //Color del contorno cuando está seleccionado
                        borderColor: theme.SEVENB,
                    }
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {   //Color del contorno al pasar el mouse
                    borderColor: theme.SEVENB,
                },
                "& .MuiInputBase-input": {
                    color: theme.ONED, //Color del texto
                },
                "& .MuiInputBase-input::placeholder": {
                    color: theme.Lao, //Placeholder color
                    opacity: 1
                },
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: error ? theme.Red : (hasValue ? theme.SEVENB : theme.Ey),  //Color del contorno
                    borderWidth: error ? '1.5px' : '1px'
                }
            }}
            InputProps={{
                endAdornment:(
                    <InputAdornment position="end">
                        <Search style={{color: isDark? theme.SEVENB : theme.Audi}}/>
                    </InputAdornment>
                ),
            }}
            
        />
    );
  };

export default SearchBox; 